import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ls-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      id="{{ btnId }}"
      type="{{ btnType }}"
      [ngClass]="class"
      (click)="onClickButton($event)"
      [disabled]="disabled"
      tabindex="0"
      (mouseenter)="setHoverIcon()"
      (mouseleave)="setIcon()"
    >
      <ng-content></ng-content>
      @if (hasIcon()) {
        <img alt="" [src]="iconSrc" />
      }
      <span class="btnLabel">{{ label }}</span>
    </button>
  `,
  styleUrls: ['./ls-button.component.scss'],
})
export class LsButtonComponent implements OnInit {
  @Input() label!: string;
  @Input() disabled: boolean = false;
  @Input() btnId: string = 'btn';
  @Input() btnType: string = 'button';
  @Input() btnVariant: 'primary' | 'primary-rounded' | 'secondary' | 'tertiary' | 'rounded' | 'icon-button' | 'icon-push' | 'primary-icon' | 'icon-primary' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'md-lg' | 'lg-md' | 'newList' = 'md';
  @Input() upcase: boolean = true;
  @Input() block: boolean = false;
  @Input() inline: boolean = false;
  @Input() btnClass = '';
  @Input() compactLabel: boolean = false;
  @Input() icon:
    | 'preview'
    | 'bookmark'
    | 'bookmark-saved'
    | 'social'
    | 'up'
    | 'down'
    | 'left'
    | 'right'
    | 'add'
    | 'menu'
    | 'menu-no-circle'
    | 'play'
    | 'wplay'
    | 'close'
    | 'close-small'
    | 'unmute'
    | 'schedule'
    | 'list-view'
    | 'grid-view'
    | 'search'
    | 'search-small'
    | 'mark'
    | 'outside-link'
    | 'edit-icon'
    | 'alert-done'
    | 'live-event'
    | 'webinar'
    | 'download'
    | '' = '';

  @Output() onClick = new EventEmitter<Event>();

  iconSrc: string = '';

  ngOnInit(): void {
    if (this.hasIcon()) {
      this.setIcon();
    }
  }

  onClickButton(event: Event): void {
    this.onClick.emit(event);
  }

  get class(): string[] {
    let cssClass = `btn-${this.size} ${this.btnVariant} ${this.btnClass}`;
    if (this.block) cssClass += ' w-full';
    if (this.upcase) cssClass += ' upcase';
    if (this.inline) cssClass += ' inline';
    if (this.compactLabel) cssClass += ' compact-label';
    return [cssClass];
  }

  setIcon(): void {
    if (this.hasIcon()) {
      this.iconSrc = `assets/icons/${this.icon}.svg`;
    }
  }

  setHoverIcon(): void {
    if (this.hasIcon()) {
      this.iconSrc = `assets/icons/${this.icon}-hover.svg`;
    }
  }

  hasIcon(): boolean {
    return ['icon-button', 'tertiary', 'icon-push', 'primary-icon', 'icon-primary'].includes(this.btnVariant) || !!this.icon;
  }
}
